import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForClient } from './mapData';

export async function getAgreements() {
  try {
    const agreements = await getRequest(`${AWS_API_URL}/agreements`, await authorize());
    return Promise.resolve(
      agreements.map((agreement) => mapDataForClient(agreement)),
    );
  } catch (error) {
    return Promise.reject(error);
  }
}
